import React, { useEffect, useState } from 'react';
import { useScrollSpy } from '../hooks/useScrollSpy';
interface NavItem {
  id: string;
  label: string;
}
const navItems: NavItem[] = [{
  id: 'overview',
  label: 'ABOUT PROJECT'
}, {
  id: 'challenge',
  label: 'THE CHALLENGE'
}, {
  id: 'solution',
  label: 'THE SOLUTION'
}, {
  id: 'methodology',
  label: 'METHODOLOGY'
}, {
  id: 'features',
  label: 'KEY FEATURES'
}, {
  id: 'impact',
  label: 'IMPACT'
}];
export function ContentNavigationChaos() {
  const [isScrolled, setIsScrolled] = useState(false);
  const activeId = useScrollSpy(navItems.map(item => item.id), 120);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    const element = document.getElementById(id);
    if (element) {
      const offset = 100;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };
  return <nav className={`hidden lg:block sticky self-start w-48 flex-shrink-0 transition-all duration-300 ${isScrolled ? 'top-[196px]' : 'top-24'}`} data-id="element-116">
      <div className="space-y-1" data-id="element-117">
        <h4 className="text-[10px] text-gray-500 uppercase tracking-[0.15em] font-medium mb-6 pl-4" data-id="element-118">
          CONTENT
        </h4>
        <ul className="space-y-3" data-id="element-119">
          {navItems.map(item => {
          const isActive = activeId === item.id;
          return <li key={item.id} data-id="element-120">
                <a href={`#${item.id}`} onClick={e => handleClick(e, item.id)} className={`block text-[11px] uppercase tracking-[0.1em] py-1.5 pl-4 border-l-2 transition-all duration-200 ${isActive ? 'border-white text-white font-medium' : 'border-transparent text-gray-500 hover:text-gray-300 hover:border-gray-600'}`} data-id="element-121">
                  {item.label}
                </a>
              </li>;
        })}
        </ul>
      </div>
    </nav>;
}